import { Checkbox } from '@cian/ui-kit/checkbox';
import { SelectDesktop } from '@cian/ui-kit/select';
import * as React from 'react';

import { EPublishPeriod } from 'shared/common/packages/api-models/common/json_query';

import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

interface IPublicationDateProps {
  publishPeriod: EPublishPeriod | null;
  hasPhoto: boolean | null;
  hasVideo: boolean | null;
  onPublishPeriodChange(period: EPublishPeriod | null): void;
  onHasPhotoChange(withPhoto: boolean | null): void;
  onHasVideoChange(withVideo: boolean | null): void;
}

interface IPublicationDate {
  label: string;
  value: EPublishPeriod;
}

const PUBLICATION_DATE_OPTIONS: IPublicationDate[] = [
  { label: 'Неважно', value: EPublishPeriod.Any },
  { label: 'За месяц', value: EPublishPeriod.Month },
  { label: 'За неделю', value: EPublishPeriod.Week },
  { label: 'За сегодня', value: EPublishPeriod.Today },
  { label: 'За час', value: EPublishPeriod.Hour },
];

export const PublicationDate: React.FC<IPublicationDateProps> = ({
  publishPeriod,
  hasPhoto,
  hasVideo,
  onPublishPeriodChange,
  onHasPhotoChange,
  onHasVideoChange,
}) => {
  return (
    <Filter label="Дата публикации">
      <InlineFilterGroup>
        <InlineFilter>
          <SelectDesktop
            options={PUBLICATION_DATE_OPTIONS}
            value={publishPeriod !== null ? publishPeriod : EPublishPeriod.Any}
            onChange={(value: EPublishPeriod) => onPublishPeriodChange(value === EPublishPeriod.Any ? null : value)}
          />
        </InlineFilter>
        <InlineFilter>
          <Checkbox
            label="Фото"
            checked={!!hasPhoto}
            onChange={event => onHasPhotoChange(event.target.checked || null)}
          />
        </InlineFilter>
        <InlineFilter>
          <Checkbox
            label="Видео"
            checked={!!hasVideo}
            onChange={event => onHasVideoChange(event.target.checked || null)}
          />
        </InlineFilter>
      </InlineFilterGroup>
    </Filter>
  );
};
